import { createFileRoute } from '@tanstack/react-router'
import { SpecialsPage } from '@/pages/specials'

export const Route = createFileRoute('/_authenticated/specials')({
  staticData: { title: 'Specials' },
  component: SpecialsPage,
})
